import React from 'react';

export default ({ component: Component, ...args }) => {
  return (
    <React.Suspense fallback={false}>
      <Component {...args} />
    </React.Suspense>
  );
};
